// services.component.ts
import { Component } from '@angular/core';
import { ServiceComponent } from '../../components/serviceCard/service.component';
import { CommonModule } from '@angular/common';
import { MatomoTrackingService } from '../../services/matomo-tracking.service';

@Component({
  selector: 'app-services',
  standalone: true,
  imports: [ServiceComponent, CommonModule],
  templateUrl: './services.component.html',
  styleUrl: './services.component.scss'
})
export class ServicesComponent {

  // Inyectar el servicio de Matomo
  constructor(private matomoService: MatomoTrackingService) {}

  /**
   * Método para trackear clicks en botones de servicios
   */
  onServiceButtonClick(buttonId: string, buttonText: string): void {
    // Trackear el evento en Matomo
    this.matomoService.trackEvent(
      'services',           // Categoría: servicios
      'button_click',       // Acción: click en botón
      `${buttonId}_${buttonText}`, // Nombre: ID + texto del botón
      1                     // Valor: contador
    );

    console.log(`📊 Evento rastreado: ${buttonId} - ${buttonText}`);
  }

  /**
   * Métodos específicos para cada botón
   */
  onContactanosClick(): void {
    this.onServiceButtonClick('service_1_contactanos', 'Contáctanos');
  }

  onSuscribeteClick(): void {
    this.onServiceButtonClick('service_2_suscribete', 'Suscríbete');
  }

  onUneteClick(): void {
    this.onServiceButtonClick('service_3_unete', 'Únete');
  }
}
